// extracted by mini-css-extract-plugin
module.exports = {"label":"logo_label__2_uFs","dark":"logo_dark__1LbOl","collapsed":"logo_collapsed__3KhCq"};